
import { useEffect } from 'react';
import { useSnackbar } from 'notistack';

let enqueueSnackbarCallBack = undefined;

export const enqueueSnackbar = (...data) => enqueueSnackbarCallBack && enqueueSnackbarCallBack(...data)

export default function useCommonSnackbar() {
    const { enqueueSnackbar: es } = useSnackbar();

    useEffect(() => {
        enqueueSnackbarCallBack = es
        return () => {
            enqueueSnackbarCallBack = undefined;
        }
    }, [es])
}